module.exports = {"620725101":"清泉镇","620725102":"位奇镇","620725103":"霍城镇","620725104":"陈户镇","620725105":"大马营镇","620725106":"东乐镇","620725203":"老军乡","620725204":"李桥乡","620725400":"国营山丹农场","620725402":"中牧公司山丹马场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620725.json
// module id = 2711
// module chunks = 0